import { ApiClient, ApiError } from "./ApiClient";
import { EDocumentImportRow } from "@utils/edocumentImport/core/buildEDocumentPayload";
import { ImportEDocumentType } from "@utils/edocumentImport/core/types";
import { parseFailures, runImportInBatches } from "@utils/import/core/sendBatches";
import { ImportProgress, ImportSummary } from "@utils/import/core/types";

export type { ImportProgress, ImportSummary };

/**
 * Documentos por invocacion.
 *
 * Mas chico que el de clientes o productos (100) porque cada documento son varias escrituras:
 * cabecera, lineas y pagos. Con 25 el lote se mantiene lejos del timeout de la lambda y el
 * progreso sigue siendo fino.
 */
export const EDOCUMENT_IMPORT_BATCH_SIZE = 25;

/**
 * Envia los comprobantes ya resueltos a la lambda de carga, en lotes secuenciales.
 *
 * Es agnostica del tipo de documento: `documentType` selecciona la entrada del registry de la
 * lambda, asi que cuando se agreguen notas de credito o debito esta funcion no cambia.
 */
export async function importEDocuments(
    documentType: ImportEDocumentType,
    rows: EDocumentImportRow[],
    onProgress?: (progress: ImportProgress) => void
): Promise<ImportSummary> {
    return runImportInBatches<EDocumentImportRow>(
        rows,
        async (batch) => {
            const { data, errors } = await ApiClient.mutations.importEDocumentsMutation({
                documentType,
                rows: JSON.stringify(batch),
            });

            if (errors?.length) {
                throw new ApiError("Error al cargar los comprobantes", "API_ERROR", errors);
            }
            if (!data?.ok) {
                throw new ApiError(data?.error || "No fue posible cargar los comprobantes", "API_ERROR");
            }

            return {
                createdCount: data.createdCount || 0,
                updatedCount: 0,
                failures: parseFailures(data.failed),
            };
        },
        onProgress,
        EDOCUMENT_IMPORT_BATCH_SIZE
    );
}
